import "./scrollColumn.scss";
const ScrollColumn = ({ items, value, onSelect }) => {
	return (
		<div
			className="scrollColumnContainer"
		>
			{items.map(item => (
				<div 
					key={item}
					onClick={() => onSelect(item)} 
					className="scrollCol"
					style={{ 
						color: value === item ? "white" : "black",
						background: value === item ? "#00a9e0" : "transparent",
						fontWeight: value === item ? "600" : "400",
					}}
				>
					{item}
				</div>
			))}
		</div>
	);
};

export default ScrollColumn;